var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input",class:{ 'is-dark': _vm.darkTheme },attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength,"max":_vm.max,"min":_vm.min,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.handleInput($event.target.value)},"blur":_vm.handleBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }